import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatchTrackerService } from '../match-tracker/match-tracker.service';
import { BoardHelpService } from '../match-tracker/tracker-board/board-help.service';
import { ThemeService } from '../_core/services/theme.service';
import { Game, GameFormat } from '../_shared/models/game.model';
import { Match } from '../_shared/models/match.model';
import { Point } from '../_shared/models/point.model';
import { DisciplineEnum } from '../_shared/models/csTypes/enums/discipline';
import { ScoreFormat, SetType } from '../_shared/models/score-format.model';

@Component({
  standalone: false,
    selector: 'app-score-list',
    templateUrl: './score-list.page.html',
    styleUrls: ['./score-list.page.scss'],
})
export class ScoreListPage implements OnInit, OnChanges {
    @Input() match: Match;
    @Input() isOfficial: boolean;

    winReason: any;

    selectedSet: number;
    participantSide1: string;
    participantSide2: string;

    sideColors: string[] = ['#3f51b5', '#009688'];

    point = {
        0: '0',
        1: '15',
        2: '30',
        3: '40',
        4: 'A'
    };
    rowStyle: string;
    scoreFormat: ScoreFormat;

    constructor(
        private translateService: TranslateService,
        private bhs: BoardHelpService,
        private matchTrackerService: MatchTrackerService,
        private themeService: ThemeService
    ) { }

    ngOnChanges(change: SimpleChanges) {
        this.match = change.match.currentValue;
    }

    ngOnInit() {
        this.selectedSet = this.match.sets.length;
        this.participantSide1 = this.bhs.getPlayersNames(this.match, 1);
        this.participantSide2 = this.bhs.getPlayersNames(this.match, 2);

        if (this.themeService.isDarkMode) {
            this.sideColors = ['#03a9f4', '#8bc34a'];
        }

        this.rowStyle = this.matchTrackerService.getRowStyle(this.sideColors, false);

        this.translateService.get(['Ace', 'Double Fault', 'Winner', 'Forced Error', 'Unforced Error']).subscribe(
            t => {
                this.winReason = {
                    A: t.Ace,
                    DF: t['Double Fault'],
                    W: t.Winner,
                    F: t['Forced Error'],
                    U: t['Unforced Error']
                };
            }
        );

        this.scoreFormat = this.bhs.getScoreFormat(this.match.matchFormat, this.match.discipline);
    }

    selectSet(ev) {
        this.selectedSet = Number(ev.detail.value);
    }

    getScore(gameFormat, score) {
        return gameFormat === GameFormat.TIEBREAK || this.match.discipline === DisciplineEnum.PICKLEBALL || this.scoreFormat.setType === SetType.TIMED ? score : this.point[score];
    }

    returnMade(point: Point) {

        if (point.winReason === 'A' || point.shots.find(shot => shot.shotDetail === 'RE' && shot.shotOutcome === 'O')) {
            return 'missed';
        } else if (point.winReason === 'DF') {
            return '';
        }
        return 'made';

    }

    getServeLocation(point: Point) {
        let serveLocation = '';
        point.shots.forEach(shot => {
            if (shot.shotType === 'SE' && shot.shotOutcome === 'I' && shot.bounceAt) {
                serveLocation = shot.bounceAt;
            }
        });

        return serveLocation;
    }

    isBeginningOfGame(game: Game) {
        return game.side1Score === 0 && game.side2Score === 0;
    }

    isFirstServeMissed(point: Point): boolean {
        return point.shots.length && point.shots[0].shotType === 'SE' && (point.shots[0].shotOutcome === 'O' || point.shots[0].shotOutcome === 'FOOT_FAULT');
    }

    isServer(point: Point, game: Game, isGameRow: boolean, sideNumber): boolean {
        return point.server?.sideNumber === sideNumber && (!isGameRow || (isGameRow && !this.isBeginningOfGame(game)));
    }

}
